// How long you want the animation to take, in ms
const animationDuration = 2000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * (2 - t);

// Function to parse the number properly, handling commas
const parseNumber = numString => {
    return parseInt(numString.replace(/,/g, ''), 10);
};

// The animation function, which takes an Element
const animateCountUp = el => {
    let frame = 0;
    const countTo = parseNumber(el.innerHTML);
    // Start the animation running 60 times per second
    const counter = setInterval(() => {
        frame++;
        // Calculate our progress as a value between 0 and 1
        // Pass that value to our easing function to get our
        // progress on a curve
        const progress = easeOutQuad(frame / totalFrames);
        // Use the progress value to calculate the current count
        const currentCount = Math.round(countTo * progress);

        // If the current count has changed, update the element
        const formattedCount = currentCount.toLocaleString(); // Add commas back to the number
        if (el.innerHTML !== formattedCount) {
            el.innerHTML = formattedCount;
        }

        // If we’ve reached our last frame, stop the animation
        if (frame === totalFrames) {
            clearInterval(counter);
        }
    }, frameDuration);
};

// Run the animation on all elements with a class of ‘countup’
const runAnimations = () => {
    const countupEls = document.querySelectorAll('.o-aligned-stats-block__number');
    countupEls.forEach(animateCountUp);
};

window.onload = runAnimations; // Corrected syntax for window onload event
